var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35183"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 846",
    cx: 40,
    cy: 40,
    r: 38.75,
    fill: "#F8F8F8",
    stroke: "#FB6B21",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 35154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.6199 26.3407C45.4475 27.7397 45.2757 29.3263 45.1033 30.8184C44.845 32.9639 44.5867 35.0163 44.3284 37.1618C44.0701 39.3073 43.8118 41.3597 43.5535 43.5052C43.3812 44.9043 43.2094 46.304 43.037 47.7031C42.8646 49.0091 42.348 50.0353 41.2283 50.5949C39.9368 51.1545 38.4724 50.5949 37.9558 49.1958C37.5251 48.1696 37.4392 47.0503 37.2668 45.9303C36.9227 43.4113 36.6638 40.9859 36.3196 38.4669C36.0613 36.0416 35.7165 33.6157 35.4582 31.2835C35.2858 29.8844 35.1999 28.5784 34.9416 27.1785C34.3391 24.5677 35.8889 22.3293 37.611 21.3029C41.0552 19.1574 44.9309 21.8626 45.5334 25.3141C45.6199 25.5939 45.6199 25.8737 45.6199 26.3403L45.6199 26.3407Z",
    fill: "#FB6B21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.8003 52.9765C42.8872 52.9765 44.5388 55.0166 44.5388 57.3473C44.5388 59.6786 42.7999 61.6213 40.7128 61.6213C38.6259 61.5244 36.8869 59.5812 36.9743 57.2505C36.975 54.6277 38.8006 52.8797 40.8003 52.9765Z",
    fill: "#FB6B21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ff98b84669edaf4c77418ab132aa6531.svg";
export { ForwardRef as ReactComponent };